import { defineStore } from 'pinia'

import { useStorage } from '@vueuse/core'

const language = import.meta.env.VITE_DEFAULT_LANG as string

export default defineStore('lang', () => {
  const lang = useStorage('lang', language as string)
  return { lang }
})
